import { proxy } from 'valtio';

interface ToastState {
  isToastAlertShowing: boolean;
  toastId: string | null;
  toastTitle: string;
  toastMessage: string;
  confirmMessage: string;
  onConfirm: (() => void) | null;
  onCancel: (() => void) | null;
  confirmText: string;
  cancelText: string;
}

export const toastStore = proxy<ToastState>({
  isToastAlertShowing: false,
  toastId: null,
  toastTitle: '',
  toastMessage: '',
  confirmMessage: '',
  onConfirm: null,
  onCancel: null,
  confirmText: 'Confirm',
  cancelText: 'Cancel',
});

export const toastActions = {
  showToastAlert: (
    title: string,
    message: string = '',
    confirmMessage: string = '',
    onConfirm: () => void,
    onCancel: () => void,
    confirmText: string = 'Confirm',
    cancelText: string = 'Cancel',
  ) => {
    toastStore.isToastAlertShowing = true;
    toastStore.toastTitle = title;
    toastStore.toastMessage = message;
    toastStore.confirmMessage = confirmMessage;
    toastStore.onConfirm = onConfirm;
    toastStore.onCancel = onCancel;
    toastStore.confirmText = confirmText;
    toastStore.cancelText = cancelText;
  },

  hideToastAlert: () => {
    toastStore.isToastAlertShowing = false;
    toastStore.toastId = null;
    toastStore.onConfirm = null;
    toastStore.onCancel = null;
  },
};
